<template>
  <div :class="$style.container">
    <TextBlock
      :title="content.title"
      :content="content.text"/>
    <div :class="$style.content">
      <p data-anim="stagger" v-html="content.paragraph"></p>
    </div>
  </div>
</template>

<script>
import TextBlock from '@/components/TextBlock'

export default {
  props: ['content'],
  components: {
    TextBlock
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.container {
  @include grid-size();
  display: flex;
  flex-flow: column;
  padding: $big-margin-mobile;

  @include mq(sm) {
    padding: $big-margin-mobile $big-margin;
  }

  @include mq(md) {
    padding: $big-margin;
  }
}

.content {
  width: 100%;
  align-self: flex-end;
  margin-top: $standard-margin-mobile;
  color: $color-gray-brown;

  @include mq(sm) {
    width: 100%;
    columns: 2 120px;
    column-gap: $big-margin;
    margin-top: $standard-margin;
  }

  @include mq(md) {
    width: 66.66%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ParagraphBlock.vue